export enum MerchantStatus {
  NOT_STARTED = 'NOT_STARTED', //
  PROCESSING = 'PROCESSING', // 审核中
  CONFIRMING = 'CONFIRMING', // 审核通过，待签约
  SUCCESS = 'SUCCESS', // 签约成功
  REJECTED = 'REJECTED', //审核不通过
  CANCELLED = 'CANCELLED', //未签约
}

export interface MerchantInfo {
  alipayNo: string;
  status: MerchantStatus;
  reason: string;
}
export const MerchantStatusMap = {
  [MerchantStatus.NOT_STARTED]: {
    btnText: '去签约',
    statusText: '未开通',
  },
  [MerchantStatus.SUCCESS]: {
    btnText: '绑定成功',
    statusText: '已绑定',
    color: 'success',
  },
  [MerchantStatus.PROCESSING]: {
    btnText: '去查看',
    statusText: '审核中',
  },
  [MerchantStatus.CONFIRMING]: {
    btnText: '去签约',
    statusText: '审核通过',
    color: 'success',
  },
  [MerchantStatus.REJECTED]: {
    btnText: '去查看',
    statusText: '审核不通过',
    color: 'error',
  },
  [MerchantStatus.CANCELLED]: {
    btnText: '去签约',
    statusText: '未开通',
  },
};
